import React, {Component} from 'react';
import {Api} from '../../api';
import TextFieldInput from '../../components/Common/TextFieldInput'
import ButtonInput from '../../components/Common/ButtonInput'
import {connect} from 'react-redux';
import './TransactionProof.scss';
import SelectInput from "../../components/Common/SelectInput";
import {escapeRegExp} from '../../utils';

class TransactionProof extends Component {
    state = {
        transactionHash: '',
        transactionData: null,
        currency: "BTC",
        currencies: [{title: "BTC"}],
        inputData: [],
        outputData: [],
        senderAddresses: [],
        recipientAddresses: [],
        outWalletsSelected: 0,
        inWalletsSelected: 0,
        totalBtcTxAmount: 0,
        userStatus: '',
    };

    onCurrencyChange = event => {
        console.log(event.target);
        this.setState({
            currency: this.state.currencies[event.target.value].title
        });
    };

    displayIO = (ioData, isInput) => {
        ioData.forEach((ioItem, index) => {
            if (isInput) {
                const inElem = document.getElementById('inData-' + index);
                inElem.classList.remove('display-none');
            } else {
                const inElem = document.getElementById('outData-' + index);
                inElem.classList.remove('display-none');
            }
        });
    };

    onChangeIoSearch = (event) => {
        //Display all again
        this.displayIO(this.state.inputData, true);
        this.displayIO(this.state.outputData, false);

        let ioData = [];
        if (event.target.id === 'input-search') {
            ioData = this.state.inputData;
        } else {
            ioData = this.state.outputData;
        }
        const searchStr = event.target.value;
        const searchedRows = [];
        let regexp = new RegExp( '.*' + escapeRegExp(searchStr.toLowerCase()) + '.*');
        for (const ioItem of ioData) {
            const isSearchedRow = regexp.test(ioItem.address.toLowerCase());
            let isAdded = false;
            if (isSearchedRow) {
                isAdded = true;
                searchedRows.push(ioItem.address);
            }

            //Typed string is number and row has't added yet
            if (!isNaN(searchStr.toLowerCase()) && !isAdded) {
                const isSearchedRow = regexp.test(ioItem.value / 100000000 +''.toLowerCase());
                if (isSearchedRow) {
                    searchedRows.push(ioItem.address);
                }
            }
        }

        //Hide IO data related to search result
        ioData.forEach((ioItem, index) => {
            if (!searchedRows.includes(ioItem.address)) {
                if (event.target.id === 'input-search') {
                    const inElem = document.getElementById('inData-' + index);
                    inElem.classList.add('display-none');
                } else {
                    const inElem = document.getElementById('outData-' + index);
                    inElem.classList.add('display-none');
                }
            }
        });
    };

    handleInputAddresses = (index) => {
        const inputData = this.state.inputData;
        let totalBtcTxAmount = this.state.totalBtcTxAmount;
        let inWalletsSelected = this.state.inWalletsSelected;

        inputData[index].selected = !inputData[index].selected;
        if (inputData[index].selected) {
            totalBtcTxAmount += inputData[index].value;
            inWalletsSelected += 1;
        } else {
            totalBtcTxAmount -= inputData[index].value;
            inWalletsSelected -= 1;
        }
        let userStatus;
        if (totalBtcTxAmount > 0 || inWalletsSelected >= 0) {
            userStatus = 'Sender';
        } else {
            userStatus = 'Recipient';
        }
        this.setState({inputData, totalBtcTxAmount, inWalletsSelected, userStatus})
    };

    handleOutputAddresses = (index) => {
        const outputData = this.state.outputData;
        let totalBtcTxAmount = this.state.totalBtcTxAmount;
        let outWalletsSelected = this.state.outWalletsSelected;

        let hasInput = false;
        outputData[index].selected = !outputData[index].selected;
        if (outputData[index].selected) {
            totalBtcTxAmount -= outputData[index].value;
            outWalletsSelected += 1;
        } else {
            totalBtcTxAmount += outputData[index].value;
            outWalletsSelected -= 1;
            hasInput = true;
        }
        let userStatus;
        if (hasInput || totalBtcTxAmount > 0) {
            userStatus = 'Sender';
        } else {
            userStatus = 'Recipient';
        }
        this.setState({outputData, totalBtcTxAmount, outWalletsSelected, userStatus})
    };

    prepareUserData = () => {
        const data = {};
        let senderData = [];
        let recipientData = [];
        if (this.state.currency === 'BTC') {
            if (this.state.userStatus === 'Sender') {
                for (const add of this.state.inputData) {
                    if (add.selected) {
                        senderData.push({
                            address: add.address,
                            value: add.value,
                        });
                    }
                }
                for (const add of this.state.outputData) {
                    if (add.selected) {
                        senderData.push({
                            address: add.address,
                            value: add.value * -1,
                        });
                    } else {
                        recipientData.push({
                            address: add.address,
                            value: add.value,
                        })
                    }
                }
            } else {
                for (const add of this.state.inputData) {
                    senderData.push({
                        address: add.address,
                        value: add.value,
                    });
                }
                for (const add of this.state.outputData) {
                    if (add.selected) {
                        recipientData.push({
                            address: add.address,
                            value: add.value,
                        });
                    } else {
                        senderData.push({
                            address: add.address,
                            value: add.value * -1,
                        });
                    }
                }
            }

            data.hash = this.state.transactionData.data.hash;
            data.senderData = senderData;
            data.recipientData = recipientData;
            data.value = Math.abs(this.state.totalBtcTxAmount);
            data.userStatus = this.state.userStatus;
            data.totalAmount = this.state.totalBtcTxAmount;
            data.currency = 'BTC';
            data.transactionDate = this.state.transactionData.data.confirmed;
        } else {
            data.hash = transactionData.hash;
            data.nonce = transactionData.nonce;
            data.recipientWallets.push(transactionData.to);
            data.senderWallets.push(transactionData.from);
            data.transferAmount = web3.fromWei(transactionData.value, 'ether');
            data.currency = 'ETH';
        }

        return data;
    };

    onProof = () => {
        this.props.handleLoader(true);
        const data = this.prepareUserData();
        if (this.state.currency === 'BTC') {
            if (data.senderData.length < 1) {
                alert('Please select sender address');
                this.props.handleLoader(false);
                return;
            }
            if (data.recipientData.length < 1) {
                alert('Please select recipient address');
                this.props.handleLoader(false);
                return;
            }
        }
        localStorage.setItem('proof-transaction', JSON.stringify(data));
        this.props.history.push('/user/transactions/selectCompany');
    };

    getTransaction = () => {
        if (this.state.currency === 'BTC') {
            const {transactionHash} = this.state;
            Api.getTransactionBTC(transactionHash).then((response) => {
                const inputData = [];
                const transactionData = response;
                for (const input of transactionData.data.inputs) {
                    if (input.addresses == null) {
                        continue;
                    }
                    for (const address of input.addresses) {
                        const addressInput = {
                            address: address,
                            value: input.output_value
                        };

                        inputData.push(addressInput);
                    }
                }

                const outputData = [];
                for (const output of transactionData.data.outputs) {
                    if (output.addresses == null) {
                        continue;
                    }
                    for (const address of output.addresses) {
                        const addressOutput = {
                            address: address,
                            value: output.value
                        };
                        outputData.push(addressOutput);
                    }
                }
                this.setState({
                    transactionData: transactionData,
                    inputData: inputData,
                    outputData: outputData,
                    selected: false
                });
            }).catch((error) => {
                alert(error.message)
            });
        } else {
            // 0x207bc2c6f9e33dee30fba65da22a7396a7a452b9b3acc9ec27cddb807c338264
            const web3 = window.web3 || window.parent.web3;
            let {mode, ethereumAddress, balance} = this.state;
            this.props.handleLoader(true);

            if (typeof web3 === 'undefined' ||
                typeof web3.currentProvider.isMetaMask === 'undefined' ||
                !web3.currentProvider.isMetaMask) {
                setTimeout(() => this.props.handleLoader(false), 200);
                alert('Wallets is not installed');
                return null;
            } else {
                this.setState({transactionData: null});
                web3.eth.getAccounts((err, accounts) => {
                    if (accounts.length > 0) {
                        const {transactionHash} = this.state;

                        web3.eth.getTransaction(transactionHash, (err, resp) => {
                            setTimeout(() => this.props.handleLoader(false), 200);
                            if (err) {
                                alert(err.message)
                            } else {
                                this.setState({transactionData: resp});
                            }
                        })
                    } else {
                        setTimeout(() => this.props.handleLoader(false), 200);
                        alert('Wallets is installed, bot not logged on.');
                        return null;
                    }
                });
            }
        }
    };

    handleChange = event => {
        const {errors} = this.state;

        this.setState({
            [event.target.name]: event.target.value,
        });
    };

    render() {
        const {transactionHash, transactionData, totalBtcTxAmount, currency, currencies, inputData, outputData, inWalletsSelected, outWalletsSelected, userStatus} = this.state;
        // const currencies = ["ETH", "BTC"];
        // const currency = this.state.currency;
        return (
            <div className={'content-wrapper'}>
                <div className={'content'}>
                    <div className={'fields-row m-b-0'}>
                        <div className={'back-arrow'} onClick={() => this.props.history.goBack()}>←
                            Back
                        </div>
                        <div className={'content-h1'}>Declare transaction</div>
                    </div>
                    <div className={'hr-content m-b-0'}/>
                    <div className={'row'}>
                        <div className={'col-lg-3'}>
                            <h3 style={{marginTop: '25px', marginLeft: '5px'}}>Select currency:</h3>
                        </div>
                        <div className={'col-lg-9'} style={{marginTop: '10px'}}>
                            <SelectInput name='currencySelection'
                                         id='currencySelection'
                                         label={this.state.currency}
                                         isValue={true}
                                         value={this.state.currency}
                                         required={true}
                                         disabled={false}
                                         classes='width-328 font-size-40'
                                         options={this.state.currencies}
                                         handleChange={(e) => this.onCurrencyChange(e)}/>
                        </div>
                    </div>
                    <div className={'content-body content-right'}>
                        <div className={'fields-row'}>
                            <TextFieldInput name='transactionHash'
                                            id={'transactionHash'}
                                            label='Transaction hash'
                                            required={true}
                                            value={transactionHash}
                                            classes='width-723'
                                            handleChange={(e) => this.handleChange(e)}/>
                            <ButtonInput
                                disabled={transactionHash === null}
                                width='141'
                                className={'dark-button black-btn'}
                                title='Search'
                                handleClick={(e) => this.getTransaction(e)}/>
                        </div>
                        {transactionData !== null &&
                        <div>
                            {/*<div className={'fields-row transaction-json">*/}
                            {/*<pre>{JSON.stringify(transactionData, null, 2)}</pre>*/}
                            {/*</div>*/}
                            {currency === 'BTC' &&
                            <div className={'row io-content'}>
                                <div className={'col-lg-5'}>
                                    <div className={'row'}>
                                        <div className={'col-lg-3 io-label'}>
                                            <h4>Inputs</h4>
                                        </div>
                                        <div className={'offset-lg-1 col-lg-8'}>
                                            <div className={'md-form'} id="input-search-block">
                                                <input className={'form-control'} type="text" placeholder="Search"
                                                       aria-label="Search" id="input-search" onChange={(e) => this.onChangeIoSearch(e)}/>
                                            </div>

                                        </div>
                                    </div>
                                    <table className={'table'}>
                                        <thead>
                                        <tr>
                                            <th scope="col" className={'wallet-selected'}>{inWalletsSelected}</th>
                                            <th scope="col">Amount</th>
                                            <th scope="col">Wallet address</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {inputData.map((address, index) => {
                                            return (
                                                <tr id={'inData-' + index} key={index}>
                                                    <td>
                                                        <input className={'big-checkbox inputAddress'} type="checkbox"
                                                               aria-label="123" id={'inputAddress-' + index}
                                                               checked={!!address.selected}
                                                               onChange={(e) => {
                                                                   this.handleInputAddresses(index)
                                                               }}/>
                                                    </td>
                                                    <td id={'inAddress-' + index}>
                                                        {Number((address.value / 100000000).toFixed(4))}
                                                    </td>
                                                    <td id={'inAddressVal-' + index}>
                                                        {address.address}
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>

                                <div className={'offset-lg-1 col-lg-6'}>
                                    <div className={'row'}>
                                        <div className={'col-lg-3 io-label'}>
                                            <h4>Outputs</h4>
                                        </div>
                                        <div className={'offset-lg-1 col-lg-8'}>
                                            <div className={'md-form" id="output-search-block'}>
                                                <input className={'form-control'} type="text" placeholder="Search"
                                                       aria-label="Search" id="output-search" onChange={(e) => this.onChangeIoSearch(e)}/>
                                            </div>

                                        </div>
                                    </div>
                                    <table className={'table'}>
                                        <thead>
                                        <tr>
                                            <th scope="col" className={'wallet-selected'}>{outWalletsSelected}</th>
                                            <th scope="col">Amount</th>
                                            <th scope="col">Wallet address</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {outputData.map((address, index) => {
                                            return (
                                                <tr id={'outData-' + index} key={index}>
                                                    <td>
                                                        <input className={'big-checkbox outAddress'} type="checkbox"
                                                               aria-label="123" id={'outAddress-' + index}
                                                               checked={!!address.selected}
                                                               onChange={(e) => {
                                                                   this.handleOutputAddresses(index)
                                                               }}/>
                                                    </td>
                                                    <td id={'outAddress-' + index}>
                                                        {Number((address.value / 100000000).toFixed(4))}
                                                    </td>
                                                    <td id={'outAddressVal-' + index}>
                                                        {address.address}
                                                    </td>
                                                </tr>
                                            )
                                        })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            }
                            <div className={'row'}>
                                <div className={'col-lg-4'}>
                                    <div className={'form-group green-border-focus'}>
                                        <textarea className={'form-control'} id="msg-text-area" rows="3" defaultValue={'Your status (Sender or Recipient) depends on which side you choose inputs or outputs.'}>
                                        </textarea>
                                        <span className={'info-icon'}></span>
                                    </div>
                                </div>
                                <div className={'col-lg-8'}>
                                    <div className={'row'}>
                                        <div className={'offset-lg-9 col-lg-3'}>
                                            <div className={'amount-block'}>
                                                <label>Total: <i
                                                    className={'user-status'}>{Math.abs(Number((totalBtcTxAmount / 100000000).toFixed(4)))} BTC</i></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'row'}>
                                        <div className={'offset-lg-9 col-lg-3'}>
                                            <div className={'status-block'}>
                                                <label>Status: <i className={'user-status'}>{userStatus}</i></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className={'row'} style={{marginTop: '10px'}}>
                                        <div className={'offset-lg-9 col-lg-3'}>
                                            <div className={'fields-row'}>
                                                <ButtonInput
                                                    id="next-button"
                                                    className={'dark-button black-btn'}
                                                    title='Next'
                                                    handleClick={(e) => this.onProof(e)}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}
                    </div>
                </div>
            </div>
        )
    }

}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(TransactionProof);


// WEBPACK FOOTER //
// ./src/views/TransactionProof/TransactionProof.js